import {useCurrentUser} from '../store/currentUser';
/**
 * Gets the current user's user level.
 * @deprecated Once new permissions system is fully in place, user levels will be removed.
 * @returns User level
 */
export const getUserLevel = () => useCurrentUser.getState().user.type;
